import moment from "moment";
import { axiosInstance as axios } from "../../redux/constants/axiosInstance";
import { API_URL } from "../constants/type";

export const GetCompletedTask = async (data) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/PerformanceVoucher/WorkCompletedList`,
      data,
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const GetProforma = async (querystring) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/PerformanceVoucher/GetPerformaforManager`,
      {
        querystring: querystring,
      },
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const BuildPO = async (data) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/PerformanceVoucher/BuildPurchaseOrder`,
      data,
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const GetProject = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/api/PerformanceVoucher/BuildPO/projectlist`,
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const GetClient = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/api/PerformanceVoucher/BuildPO/clientlist`,
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const GetProformaByProject = async (id) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/PerformanceVoucher/GetPerformaByProjectId/${id}`,
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const GetResources = async (id) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/PerformanceVoucher/BuildPO/resourcelist/${id}`,
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const MakePO = async (data) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/PerformanceVoucher/BuildPo/MakePo`,
      data,
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const DeletePO = async (id) => {
  try {
    const response = await axios.delete(
      `${API_URL}/api/PerformanceVoucher/DeletePo/${id}`,
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const SendPO = async (data) => {
  try {
    const response = await axios.put(
      `${API_URL}/api/PerformanceVoucher/SendPerformanceVoucher`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const MakeInvoice = async (id) => {
  try {
    const response = await axios.put(
      `${API_URL}/api/PerformanceVoucher/MakeInvoice/${id}`,
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const addClientPO = async (data) => {
  try {
    const response = await axios.put(
      `${API_URL}/api/PerformanceVoucher/AddClientPO`,
      data,
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const GetWorkList = async (id) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/PerformanceVoucher/BuildPO/worklist/${id}`,
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const GetPOById = async (id) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/PerformanceVoucher/GetPerformaReouces/${id}`,
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const GetNextPOId = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/api/PerformanceVoucher/GetNextPerformaId`,
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const DownloadProformaPDF = async (performaId, ProformaCode) => {
  let workspaceName = localStorage.getItem("workspaceName")?.split("-")[0];
  let selectedProject = localStorage.getItem("projectForPrint");
  let selectedQuoteNo = localStorage.getItem("QuoteNoForPrint");
  let selectedClientName = localStorage.getItem("clientNameForPrint");

  let pdfTitle = `${selectedClientName}-${selectedProject}-${workspaceName}-${selectedQuoteNo}-${moment(
    new Date(),
  ).format("YYYY.MM.DD, h:mm a")}.pdf`;

  let pdfTitle2 = `${"Proforma"}-${ProformaCode}-${moment(new Date()).format(
    "YYYY.MM.DD, h:mm a",
  )}.pdf`;

  try {
    const response = await axios.get(
      `${API_URL}/api/Files/DownloadPerformaPDF/${performaId}`,
      { responseType: "blob", headers: ["filename"] },
    );

    if (response.status == 200) {
      const downloadLink = document.createElement("a");
      downloadLink.href = URL.createObjectURL(response.data);
      downloadLink.download = pdfTitle2;
      downloadLink.click();
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const DownloadQuotesPDF = async (quoteId) => {
  let workspaceName = localStorage.getItem("workspaceName")?.split("-")[0];
  let selectedProject = localStorage.getItem("projectForPrint");
  let selectedQuoteNo = localStorage.getItem("QuoteNoForPrint");
  let selectedClientName = localStorage.getItem("clientNameForPrint");

  let pdfTitle = `${selectedClientName}-${selectedProject}-${workspaceName}-${selectedQuoteNo}-${moment(
    new Date(),
  ).format("YYYY.MM.DD, h:mm a")}.pdf`;

  try {
    const response = await axios.get(
      `${API_URL}/api/Files/DownloadQuotesReport/${quoteId}`,
      { responseType: "blob", headers: ["filename"] },
    );

    if (response.status == 200) {
      const downloadLink = document.createElement("a");
      downloadLink.href = URL.createObjectURL(response.data);
      // downloadLink.download = `Quote.pdf`;
      downloadLink.download = pdfTitle;
      downloadLink.click();
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const DownloadAndOpenQuotesPDF = async (orderid) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/PurchasingOrderDoc/${orderid}/download`,
      { responseType: "blob", headers: ["filename"] },
    );

    if (response.status == 200) {
      var fileURL = window.URL.createObjectURL(response.data);
      let tab = window.open();
      tab.location.href = fileURL;
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};
